/* eslint-disable indent */
/* eslint-disable no-shadow */
import {
  Button,
  Card,
  Dialog,
  Form,
  Message,
  NumberPicker,
  Radio,
  Select,
  Switch,
} from '@alifd/next';
import {
  CheckOutlined,
  CloseOutlined,
  DeleteOutlined,
  DownloadOutlined,
  EditOutlined,
  UploadOutlined,
} from '@ant-design/icons';
import {
  Checkbox,
  Col,
  Input,
  InputNumber,
  Row,
  Space,
  Spin,
  Table,
  Tag,
  Typography,
  Upload,
} from 'antd';
import axios from 'axios';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { SketchPicker } from 'react-color';
import ReactDragListView from 'react-drag-listview';
import Swal from 'sweetalert2';

import client from '../../../../lib/feathers';
import styles from './editTemplateContent.module.scss';

const { Item } = Form;
const { Option, OptionGroup } = Select;
const { CheckableTag } = Tag;
const BroadcastTemplateContent = (props) => {
  const uploads = client.service('uploads');
  const uploadRef = useRef(null);
  const { index, broadcastContent, setBroadcastContent } = props;
  const [showColor, setShowColor] = useState(false);
  const [TemplateDialog, setTemplateDialog] = useState(false);
  const [TemplateDialogTitle, setTemplateDialogTitle] = useState(0);
  const [TemplateDialogNum, setTemplateDialogNum] = useState(0);
  const [showAddColor, setShowAddColor] = useState(false);
  const [TemplateDialogCount, setTemplateDialogCount] = useState({
    typeContent: 'weather',
    typeFormat: '新北市',
    textSize: 20,
    textTags: [],
    textColor: '#000000',
    textLevel: 'center',
    textVertical: 'center',
    unit: 's',
    seconds: 10,
    checkMarquee: false,
    checkTextSound: false,
  });
  const [checkValue, setCheckValue] = useState(false);

  // 媒體庫
  const [TemplateImageDialog, setTemplateImageDialog] = useState(false);
  const [TemplateImageChangeDialog, setTemplateImageChangeDialog] =
    useState(false);
  const [upLoading, setUpLoading] = useState(false);
  const [mediaImage, setMediaImage] = useState(false);
  const [mediaCheckValue, setMediaCheckValue] = useState(false);
  const [mediaType, setMediaType] = useState('all');
  const [mediaIndex, setMediaIndex] = useState('');
  const [mediaUpdate, setMediaUpdate] = useState(false);

  // 即時資訊
  const [typeValueDialog, setTypeValueDialog] = useState(false);
  const [typeValue, setTypeValue] = useState({});
  const [typeValueData, setTypeValueData] = useState([]);
  const [editable, setEditable] = useState('');
  const [typeColumns, setTypeColumns] = useState([]);
  const [errorText, setErrorText] = useState('');
  const [errorTable, setErrorTable] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);

  // mp4影片
  const [uploadPath, setUploadPath] = useState('');
  const [uploadData, setUploadData] = useState(null);
  const [backgroundMusic, setBackgroundMusic] = useState(null);
  const [NewMp4, setNewMp4] = useState({ videoDuration: 0 });
  const [soundLoading, setSoundLoading] = useState(false);

  const tagsData = ['粗體', '斜體'];
  const city = [
    '台北市',
    '基隆市',
    '新北市',
    '連江縣',
    '宜蘭縣',
    '新竹市',
    '新竹縣',
    '桃園市',
    '苗栗縣',
    '台中市',
    '彰化縣',
    '南投縣',
    '嘉義市',
    '嘉義縣',
    '雲林縣',
    '台南市',
    '高雄市',
    '澎湖縣',
    '金門縣',
    '屏東縣',
    '台東縣',
    '花蓮縣',
  ];

  const unit = [
    { name: 'CO₂', unitValue: 1, unitName: 'ppm' },
    { name: 'PM₂.₅', unitValue: 1, unitName: 'μg/m³' },
    { name: 'PM₁₀', unitValue: 1, unitName: 'μg/m³' },
    { name: 'PM₁.₀', unitValue: 1, unitName: 'μg/m³' },
    { name: 'TVOC', unitValue: 1, unitName: 'mg/m³' },
    { name: 'CH₂O', unitValue: 1, unitName: 'mg/m³' },
    { name: '照度', unitValue: 1, unitName: 'lux' },
    { name: '溫度', unitValue: 1, unitName: '°C' },
    { name: '濕度', unitValue: 1, unitName: '%' },
  ];
  useEffect(() => {
    (async () => {
      const res2 = await uploads.find({
        query: {
          orignalName: {
            $regex: 'jpg|jpeg|gif|png',
          },
          $or: [{ type: 'announceBroadcast' }, { type: 'broadcast' }],
        },
      });
      setMediaImage(res2.data);
    })();
  }, [uploads, isUpdate]);

  // 時間下拉式選單
  const selectAfter = (
    <Select
      value={TemplateDialogCount.unit}
      className="select-after"
      onChange={(value) => {
        setTemplateDialogCount((prev) => {
          return {
            ...prev,
            unit: value,
          };
        });
      }}
    >
      <Option value="s">秒</Option>
      <Option value="m">分</Option>
    </Select>
  );

  // tag處理
  const handleChange = (tag, checked) => {
    const nextSelectedTags = checked
      ? [...TemplateDialogCount.textTags, tag]
      : TemplateDialogCount.textTags.filter((t) => t !== tag);

    setTemplateDialogCount((prev) => {
      return {
        ...prev,
        textTags: nextSelectedTags,
      };
    });
  };

  const onDragCategoryEnd = (fromIndex, toIndex, count) => {
    const items = broadcastContent[index].children; // 所有類別資料
    const item = items.splice(fromIndex, 1)[0];
    items.splice(toIndex, 0, item); // 把刪除的新增到移動的位置
    const newBroadcastContent = [...broadcastContent];
    newBroadcastContent[index].children = items;
    setBroadcastContent(newBroadcastContent);
    Message.success('拖曳成功');
  };
  // 回初始值
  const onChangeInitialValue = () => {
    const obj = {
      typeContent: 'weather',
      typeFormat: '新北市',
      textSize: 20,
      textTags: [],
      textColor: '#000000',
      textLevel: 'center',
      textVertical: 'center',
      unit: 's',
      seconds: 10,
      checkMarquee: false,
      checkTextSound: false,
      startTime: 1,
      endTime: 10,
      sound: 0,
    };
    setTemplateDialogCount({ ...obj });
    setTypeValueData([]);
    setUploadData(null);
    setUploadPath(null);
    setBackgroundMusic(null);
  };
  // 新增/編輯
  const onChangeTemplateContent = (value) => {
    if (
      TemplateDialogCount.typeContent === 'youtube' &&
      TemplateDialogCount.typeFormat.indexOf('?v=') < 0
    ) {
      Message.error('輸入網址錯誤');
      return;
    }
    let NewBackgroundMusic = { ...backgroundMusic };
    if (uploadData) {
      NewBackgroundMusic = NewMp4;
    }
    if (
      TemplateDialogCount.typeContent === 'mp4' &&
      NewBackgroundMusic?.path === undefined
    ) {
      Message.error('請上傳檔案');
      return;
    }
    let newBroadcastContent = structuredClone(broadcastContent);
    let newDialogCount = [];

    if (value === 'image') {
      newDialogCount = mediaCheckValue;
    } else {
      newDialogCount = [TemplateDialogCount];
    }
    if (TemplateDialogCount.seconds === '') newDialogCount[0].seconds = 1;
    if (TemplateDialogCount.typeContent === 'mp4') {
      newDialogCount[0].url = NewBackgroundMusic;
      newDialogCount[0].maxEndTime = NewBackgroundMusic.videoDuration;
    }

    console.log(TemplateDialogTitle);
    if (TemplateDialogTitle === 'insert') {
      newBroadcastContent[index].children.push(...newDialogCount);
    } else {
      newBroadcastContent[index].children[TemplateDialogNum] =
        newDialogCount[0];
    }
    console.log(newBroadcastContent);
    console.log(newBroadcastContent === broadcastContent);
    setBroadcastContent(newBroadcastContent);
    setTypeValueData([]);
    setUploadData(null);
    setUploadPath(null);
    setBackgroundMusic(null);
    setTemplateDialog(false);
  };
  // 刪除
  const onDeleteValue = (index, num) => {
    setBroadcastContent((broadcastContent) => {
      let newBroadcastOne = structuredClone(broadcastContent);
      newBroadcastOne[index].children.splice(num, 1);
      console.log(newBroadcastOne);
      return newBroadcastOne;
    });
  };
  // console.log(broadcastContent);
  // console.log(broadcastContent[index].children, index);

  // 圖片上傳
  const beforeUpload = async (file) => {
    try {
      setUpLoading(true);
      console.log(file);
      const formData = new FormData();
      formData.append('files', file);
      await fetch('/newUploads?type=broadcast&createCompressImage=true', {
        method: 'POST',
        body: formData,
        headers: { authorization: window.localStorage['feathers-jwt'] },
      });
      const res2 = await uploads.find({
        query: {
          orignalName: {
            $regex: 'jpg|jpeg|gif|png',
          },
          $or: [{ type: 'announceBroadcast' }, { type: 'broadcast' }],
        },
      });
      Message.success('上傳成功');
      setMediaImage(res2.data);
      setUpLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  // 選擇媒體庫圖片
  const onChange = (checkedValues) => {
    console.log(checkedValues);
    const newMediaImage = [];
    for (let i = 0; i < checkedValues.length; i++) {
      const checkValue = {
        ...TemplateDialogCount,
        typeContent: 'image',
        typeFormat: checkedValues[i],
        textSize: 'fullVersion',
        textTags: '',
        textColor: '',
      };
      newMediaImage.push(checkValue);
    }
    console.log(newMediaImage);
    setMediaCheckValue(newMediaImage);
  };
  // 媒體庫類別篩選
  const onChangeMediaType = async (value) => {
    let res2 = '';
    if (value === 'all') {
      res2 = await uploads.find({
        query: {
          orignalName: {
            $regex: 'jpg|jpeg|gif|png',
          },
          $or: [{ type: 'announceBroadcast' }, { type: 'broadcast' }],
        },
      });
    } else {
      res2 = await uploads.find({
        query: {
          orignalName: {
            $regex: 'jpg|jpeg|gif|png',
          },
          $or: [{ type: value }],
        },
      });
    }

    setMediaImage(res2.data);
  };
  // 拖拉即時資訊欄位變更順序
  const onTypeDragCategoryEnd = (fromIndex, toIndex) => {
    const items = typeValueData; // 所有類別資料
    const item = items.splice(fromIndex, 1)[0];
    items.splice(toIndex, 0, item); // 把刪除的新增到移動的位置
    const newTypeValueData = [...items];
    setTypeValueData(newTypeValueData);
    Message.success('拖曳成功');
  };

  // 刪除媒體庫資料
  const onDeleteBox = () => {
    for (let i = 0; i < mediaCheckValue.length; i++) {
      uploads
        .find({ query: { showPath: mediaCheckValue[i].typeFormat } })
        .then((res) => {
          uploads
            .remove(res.data[0]._id)
            .then(() => {
              Message.success('刪除成功');
              setMediaCheckValue();
              uploads
                .find({
                  query: {
                    orignalName: {
                      $regex: 'jpg|jpeg|gif|png',
                    },
                    $or: [{ type: 'announceBroadcast' }, { type: 'broadcast' }],
                  },
                })
                .then((res2) => {
                  setMediaImage(res2.data);
                })
                .catch((err) => {
                  console.log(err);
                });
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  return (
    <>
      <Card free className={styles.card}>
        <Card.Content>
          <h1>
            區塊{index === 0 && '一'}
            {index === 1 && '二'}
            {index === 2 && '三'}
          </h1>
          <div className={styles.ContentSetting}>
            {/* <Button
              className={styles.buttonAdd}
              onClick={() => {
                setTemplateDialog(true);
                // setTemplateDialogNum(index);
                setTemplateDialogTitle('insert');
                onChangeInitialValue();
              }}
            >
              新增
            </Button> */}
            <Button
              className={styles.buttonAdd}
              onClick={() => {
                setTemplateDialog(true);
                setTemplateDialogTitle('insert');
                onChangeInitialValue();
              }}
            >
              新增內容
            </Button>
            {/* <Button
              className={styles.buttonAdd}
              onClick={() => {
                setTemplateImageDialog(true);
                setTemplateDialogTitle('insert');
                onChangeInitialValue();
              }}
            >
              <DownloadOutlined />
              從媒體庫匯入
            </Button> */}
            <div className={styles.Setting}>
              循環輪播：
              <Switch
                checked={broadcastContent[index]?.carousel}
                onChange={(value) => {
                  const newbroadcastContent = [...broadcastContent];
                  newbroadcastContent[index].carousel = value;
                  setBroadcastContent(newbroadcastContent);
                }}
              />
            </div>
            <div className={styles.Setting}>
              背景顏色：
              <div>
                <div style={{ display: 'inline-flex' }}>
                  <div
                    className={styles.color}
                    style={{
                      backgroundColor: broadcastContent[index]?.color,
                    }}
                    onClick={() => setShowColor(true)}
                  />
                  <Input
                    value={broadcastContent[index]?.color}
                    onClick={() => setShowColor(true)}
                    onChange={(e) => {
                      const newbroadcastContent = [...broadcastContent];
                      newbroadcastContent[index].color = e.target.value;
                      setBroadcastContent(newbroadcastContent);
                    }}
                  />
                </div>
                {showColor && (
                  <>
                    <div
                      className={styles.cover}
                      onClick={() => setShowColor(false)}
                    />
                    <SketchPicker
                      className={styles.colorPicker}
                      color={broadcastContent[index]?.color}
                      onChangeComplete={(color) => {
                        const newbroadcastContent = [...broadcastContent];
                        newbroadcastContent[index].color = color.hex;
                        setBroadcastContent(newbroadcastContent);
                      }}
                    />
                  </>
                )}
              </div>
            </div>
            <div className={styles.Setting}>
              區塊大小：
              <InputNumber
                value={broadcastContent[index]?.size}
                min={1}
                max={100}
                style={{
                  width: '30%',
                }}
                onChange={(value) => {
                  const newbroadcastContent = [...broadcastContent];
                  newbroadcastContent[index].size = value;
                  setBroadcastContent(newbroadcastContent);
                }}
              />
            </div>
          </div>
          <p>
            <font style={{ color: 'red' }}>*</font>可拖曳表格欄位變換順序
          </p>
          <ReactDragListView
            onDragEnd={(fromIndex, toIndex) =>
              onDragCategoryEnd(fromIndex, toIndex, index)
            }
          >
            <Table
              dataSource={broadcastContent[index]?.children}
              bordered
              scroll={{ x: 'max-content' }}
            >
              <Table.Column
                title="類別"
                dataIndex="typeContent"
                width={150}
                align="center"
                render={(value) => {
                  if (value === 'weather') {
                    return <>天氣</>;
                  } else if (value === 'date') {
                    return <>日期</>;
                  } else if (value === 'time') {
                    return <>時間</>;
                  } else if (value === 'dateTime') {
                    return <>日期時間</>;
                  } else if (value === 'text') {
                    return <>文字內容</>;
                  } else if (value === 'image') {
                    return <>圖片</>;
                  } else if (value === 'youtube') {
                    return <>youtube影片</>;
                  } else if (value === 'mp4') {
                    return <>MP4影片</>;
                  } else {
                    return <>{value}</>;
                  }
                }}
              />
              <Table.Column
                title="內容"
                dataIndex="typeFormat"
                width={150}
                align="center"
                render={(value, record) => {
                  if (record.typeContent === 'image') {
                    return (
                      <>
                        <img
                          src={value}
                          width="100%"
                          alt="圖片"
                          style={{ width: '100px' }}
                        />
                      </>
                    );
                  } else if (
                    record.typeContent === '空氣品質' ||
                    record.typeContent === '溫度' ||
                    record.typeContent === '濕度' ||
                    record.typeContent === '照度' ||
                    record.typeContent === '自定義'
                  ) {
                    return (
                      <>
                        {value.length > 0 &&
                          value.map((item, index) => (
                            <div key={index}>
                              裝置名稱：{item.originName}；顯示名稱：
                              {item.newName}
                            </div>
                          ))}
                      </>
                    );
                  } else if (
                    record.typeContent === 'youtube' ||
                    record.typeContent === 'mp4'
                  ) {
                    return <>{record.youtubeTitle}</>;
                  } else {
                    return (
                      <>
                        {value.split('\n').map((i) => (
                          <>
                            {i}
                            <br />
                          </>
                        ))}
                      </>
                    );
                  }
                }}
              />
              <Table.Column
                title="樣式"
                dataIndex="textColor"
                width={200}
                align="center"
                render={(value, record) => {
                  if (record.typeContent === 'image') {
                    return (
                      <>
                        <div>
                          樣式：
                          {(record.textSize === 'fullVersion' && '滿版') ||
                            (record.textSize === 'originalSize' && '原尺寸') ||
                            (record.textSize === 'repeat' && '重複填滿')}
                        </div>
                        <div style={{ textAlign: 'center' }}>
                          位置：水平
                          {(record.textLevel === 'center' && '置中') ||
                            (record.textLevel === 'left' && '靠左') ||
                            (record.textLevel === 'right' && '靠右')}
                        </div>
                      </>
                    );
                  } else {
                    return (
                      <>
                        <div>
                          大小：{record.textSize}px；
                          {record.textTags.map((x) => x)}
                        </div>
                        <div
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                          }}
                        >
                          顏色：
                          <div
                            className={styles.color}
                            style={{
                              backgroundColor: value,
                            }}
                          />
                          {value}
                        </div>
                        <div style={{ textAlign: 'center' }}>
                          位置：水平
                          {(record.textLevel === 'center' && '置中') ||
                            (record.textLevel === 'left' && '靠左') ||
                            (record.textLevel === 'right' && '靠右')}
                          ；垂直
                          {(record.textVertical === 'center' && '置中') ||
                            (record.textVertical === 'start' && '靠上') ||
                            (record.textVertical === 'end' && '靠下')}
                        </div>
                      </>
                    );
                  }
                }}
              />
              <Table.Column
                title="時間"
                dataIndex="seconds"
                width={150}
                align="center"
                render={(value, record) => {
                  if (record.typeContent === 'youtube') {
                    return (
                      <div style={{ textAlign: 'center' }}>
                        {record.startTime}秒~{record.endTime}秒 (共{value}秒)
                      </div>
                    );
                  } else {
                    return (
                      <div style={{ textAlign: 'center' }}>
                        {value}
                        {record.unit === 's' ? '秒' : '分'}
                      </div>
                    );
                  }
                }}
              />
              <Table.Column
                title="操作"
                width={100}
                align="center"
                render={(_value, record, num) => {
                  return (
                    <div className={styles.btn}>
                      <Button
                        type="normal"
                        onClick={() => {
                          setTemplateDialog(true);
                          setTemplateDialogTitle('update');
                          setTemplateDialogNum(num);
                          setTemplateDialogCount(record);
                          setTypeValueData(record.typeFormat);
                          if (record.typeContent === 'mp4')
                            setBackgroundMusic(record.url);
                          const checkValue = [];
                          if (record.checkMarquee)
                            checkValue.push('checkMarquee');
                          if (record.checkTextSound)
                            checkValue.push('checkTextSound');
                          setCheckValue(checkValue);

                          let searchValue = '';

                          if (record.typeContent === '自定義') {
                            searchValue = '';
                          } else if (
                            record.typeContent === '溫度' ||
                            record.typeContent === '濕度' ||
                            record.typeContent === '照度' ||
                            record.typeContent === '空氣品質'
                          ) {
                            searchValue = record.typeContent;
                          }
                          axios
                            .get(`/ezcon/api/mqttTopic?topic=${searchValue}`, {
                              headers: {
                                authorization:
                                  localStorage.getItem('feathers-jwt'),
                              },
                            })
                            .then((res) => {
                              setTypeColumns(res.data);
                            })
                            .catch((err) => {
                              console.log(err);
                            });
                        }}
                      >
                        編輯
                      </Button>
                      <Button
                        type="primary"
                        warning
                        onClick={() => {
                          onDeleteValue(index, num);
                        }}
                      >
                        刪除
                      </Button>
                    </div>
                  );
                }}
              />
            </Table>
          </ReactDragListView>
        </Card.Content>
      </Card>
      {/* 新增/編輯輪播內容 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={TemplateDialog}
        onOk={() => {
          onChangeTemplateContent();
        }}
        onCancel={() => {
          setTemplateDialog(false);
          onChangeInitialValue();
        }}
        onClose={() => {
          setTemplateDialog(false);
          onChangeInitialValue();
        }}
      >
        <Spin spinning={soundLoading}>
          <Form>
            <h3>
              {TemplateDialogTitle === 'insert' ? '新增' : '編輯'}輪播內容
            </h3>

            <Item label="類別" required>
              <Select
                style={{ width: '100%' }}
                value={TemplateDialogCount.typeContent}
                onChange={(value) => {
                  setTemplateDialogCount({
                    ...TemplateDialogCount,
                    typeContent: value,
                    typeFormat: '',
                  });
                  let searchValue = '';

                  if (value === '自定義') {
                    searchValue = '';
                    setTypeValueDialog(true);
                  } else if (
                    value === '溫度' ||
                    value === '濕度' ||
                    value === '照度' ||
                    value === '空氣品質'
                  ) {
                    searchValue = value;
                    setTypeValueDialog(true);
                  } else if (value === 'image') {
                    setTemplateImageDialog(true);
                  }
                  axios
                    .get(`/ezcon/api/mqttTopic?topic=${searchValue}`, {
                      headers: {
                        authorization: localStorage.getItem('feathers-jwt'),
                      },
                    })
                    .then((res) => {
                      setTypeColumns(res.data);
                    })
                    .catch((err) => {
                      console.log(err);
                    });
                }}
              >
                <OptionGroup label="一般功能">
                  <Option value="weather">天氣</Option>
                  <Option value="date">日期</Option>
                  <Option value="time">時間</Option>
                  <Option value="dateTime">日期時間</Option>
                  <Option value="text">文字內容</Option>
                  {/* {TemplateDialogTitle === 'update' && ( */}
                  <Option value="image">圖片</Option>
                  {/* )} */}
                  <Option value="youtube">youtube影片</Option>
                  <Option value="mp4">MP4影片</Option>
                  <Option value="iframe">網頁</Option>
                </OptionGroup>
                <OptionGroup label="即時資訊">
                  <Option value="空氣品質">空氣品質</Option>
                  <Option value="照度">照度</Option>
                  <Option value="濕度">濕度</Option>
                  <Option value="溫度">溫度</Option>
                  <Option value="自定義">自定義</Option>
                </OptionGroup>
              </Select>
            </Item>
            {TemplateDialogCount.typeContent === 'image' ? (
              <>
                <Item label="圖片樣式" required>
                  <Select
                    style={{ width: '100%', textAlign: 'center' }}
                    onChange={(value) => {
                      setTemplateDialogCount({
                        ...TemplateDialogCount,
                        textSize: value,
                      });
                    }}
                    value={TemplateDialogCount.textSize}
                  >
                    <Option value="fullVersion">滿版</Option>
                    <Option value="originalSize">原尺寸</Option>
                    <Option value="repeat">重複填滿</Option>
                  </Select>
                </Item>
                {TemplateDialogTitle === 'update' && (
                  <Item label="選擇圖片">
                    <Button
                      onClick={() => setTemplateImageChangeDialog(true)}
                      style={{ marginBottom: 10 }}
                    >
                      更換圖片
                    </Button>
                    <div>
                      <img
                        src={TemplateDialogCount.typeFormat}
                        width="100%"
                        alt="圖片"
                        style={{ width: '100px' }}
                      />
                    </div>
                  </Item>
                )}
              </>
            ) : (
              <>
                {TemplateDialogCount.typeContent === 'text' && (
                  <Item label="文字內容" required>
                    <Input.TextArea
                      rows={4}
                      value={TemplateDialogCount.typeFormat}
                      placeholder="請輸入文字內容"
                      onChange={(e) => {
                        setTemplateDialogCount({
                          ...TemplateDialogCount,
                          typeFormat: e.target.value,
                        });
                      }}
                    />
                    <div>
                      <Checkbox.Group
                        defaultValue={checkValue}
                        onChange={(checkedValues) => {
                          setTemplateDialogCount({
                            ...TemplateDialogCount,
                            checkMarquee:
                              checkedValues.includes('checkMarquee'),
                            checkTextSound:
                              checkedValues.includes('checkTextSound'),
                          });
                        }}
                      >
                        <Checkbox value="checkMarquee">
                          跑馬燈效果(打勾將會有文字由右至左跑動）
                        </Checkbox>
                        <Checkbox value="checkTextSound">
                          文字轉語音(打勾將會播放文字語音）
                        </Checkbox>
                      </Checkbox.Group>
                    </div>
                  </Item>
                )}
                {TemplateDialogCount.typeContent === 'iframe' && (
                  <Item label="文字內容" required>
                    <Input.TextArea
                      rows={4}
                      value={TemplateDialogCount.typeFormat}
                      placeholder="請輸入文字內容"
                      onChange={(e) => {
                        setTemplateDialogCount({
                          ...TemplateDialogCount,
                          typeFormat: e.target.value,
                        });
                      }}
                    />
                  </Item>
                )}
                {(TemplateDialogCount.typeContent === 'date' ||
                  TemplateDialogCount.typeContent === 'dateTime' ||
                  TemplateDialogCount.typeContent === 'time' ||
                  TemplateDialogCount.typeContent === 'weather') && (
                  <Item
                    label={
                      TemplateDialogCount.typeContent === 'weather'
                        ? '城市'
                        : '樣式'
                    }
                  >
                    {TemplateDialogCount.typeContent === 'date' && (
                      <Radio.Group
                        itemDirection="ver"
                        onChange={(value) => {
                          setTemplateDialogCount({
                            ...TemplateDialogCount,
                            typeFormat: value,
                          });
                        }}
                        value={TemplateDialogCount.typeFormat}
                      >
                        <Radio value="YYYY/MM/DD">
                          格式一(ex:{moment().format('YYYY/MM/DD')})
                        </Radio>
                        <Radio value="YYYY-MM-DD">
                          格式二(ex:{moment().format('YYYY-MM-DD')})
                        </Radio>
                        <Radio value="YYYY年MM月DD日dddd">
                          格式三(ex:{moment().format('YYYY年MM月DD日dddd')})
                        </Radio>
                      </Radio.Group>
                    )}
                    {TemplateDialogCount.typeContent === 'dateTime' && (
                      <Radio.Group
                        itemDirection="ver"
                        onChange={(value) => {
                          setTemplateDialogCount({
                            ...TemplateDialogCount,
                            typeFormat: value,
                          });
                        }}
                        value={TemplateDialogCount.typeFormat}
                      >
                        <Radio value="YYYY/MM/DD HH:mm:ss">
                          格式一(ex:{moment().format('YYYY/MM/DD HH:mm:ss')})
                        </Radio>
                        <Radio value="YYYY-MM-DD HH:mm:ss">
                          格式二(ex:{moment().format('YYYY-MM-DD HH:mm:ss')})
                        </Radio>
                        <Radio value="YYYY年MM月DD日dddd a hh:mm:ss">
                          格式三(ex:
                          {moment().format('YYYY年MM月DD日dddd a hh:mm:ss')})
                        </Radio>
                      </Radio.Group>
                    )}
                    {TemplateDialogCount.typeContent === 'time' && (
                      <Radio.Group
                        onChange={(value) => {
                          setTemplateDialogCount({
                            ...TemplateDialogCount,
                            typeFormat: value,
                          });
                        }}
                        value={TemplateDialogCount.typeFormat}
                      >
                        <Radio value="HH:mm">
                          格式一(ex:{moment().format('HH:mm')})
                        </Radio>
                        <Radio value="a hh:mm">
                          格式二(ex:{moment().format('a hh:mm')})
                        </Radio>
                      </Radio.Group>
                    )}
                    {TemplateDialogCount.typeContent === 'weather' && (
                      <Select
                        style={{ width: '100%', textAlign: 'center' }}
                        onChange={(value) => {
                          setTemplateDialogCount({
                            ...TemplateDialogCount,
                            typeFormat: value,
                          });
                        }}
                        value={TemplateDialogCount.typeFormat}
                      >
                        {city.map((item, index) => (
                          <Option value={item} key={index}>
                            {item}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </Item>
                )}
                {(TemplateDialogCount.typeContent === '空氣品質' ||
                  TemplateDialogCount.typeContent === '溫度' ||
                  TemplateDialogCount.typeContent === '濕度' ||
                  TemplateDialogCount.typeContent === '照度' ||
                  TemplateDialogCount.typeContent === '自定義') && (
                  <Item label="顯示欄位">
                    <Button
                      onClick={() => {
                        setTypeValueDialog(true);
                      }}
                    >
                      編輯項目內容
                    </Button>
                    <div style={{ marginTop: 10 }}>
                      {typeValueData.map((item, index) => (
                        <div key={index} style={{ marginBottom: 5 }}>
                          {index + 1}. {item.originName}({item.unitName})
                        </div>
                      ))}
                    </div>
                  </Item>
                )}
                {TemplateDialogCount.typeContent !== 'youtube' &&
                  TemplateDialogCount.typeContent !== 'mp4' &&
                  TemplateDialogCount.typeContent !== 'iframe' && (
                    <>
                      <Item label="文字樣式">
                        <NumberPicker
                          style={{ width: '70%', marginRight: 10 }}
                          defaultValue={TemplateDialogCount.textSize}
                          type="inline"
                          onChange={(value) => {
                            setTemplateDialogCount({
                              ...TemplateDialogCount,
                              textSize: value,
                            });
                          }}
                        />
                        {tagsData.map((tag) => (
                          <CheckableTag
                            key={tag}
                            checked={
                              TemplateDialogCount.textTags.indexOf(tag) > -1
                            }
                            onChange={(checked) => handleChange(tag, checked)}
                          >
                            {tag}
                          </CheckableTag>
                        ))}
                      </Item>
                      <Item label="文字顏色">
                        <div
                          className={styles.textColorContent}
                          style={{
                            backgroundColor: TemplateDialogCount.textColor,
                            border: '1px dashed #D8D8D8',
                          }}
                          onClick={() => setShowAddColor(true)}
                        />
                        <Input
                          placeholder="例如：歡迎光臨..."
                          style={{ width: '90%' }}
                          value={TemplateDialogCount.textColor}
                          onClick={() => setShowAddColor(true)}
                          onChange={(e) => {
                            setTemplateDialogCount({
                              ...TemplateDialogCount,
                              textColor: e.target.value,
                            });
                            // setTextColor(e.target.value);
                          }}
                        />
                        {showAddColor ? (
                          <>
                            <div
                              className={styles.cover}
                              onClick={() => setShowAddColor(false)}
                            />
                            <SketchPicker
                              className={styles.colorPicker}
                              color={TemplateDialogCount.textColor}
                              onChangeComplete={(color) => {
                                // setTextColor(color.hex);
                                setTemplateDialogCount({
                                  ...TemplateDialogCount,
                                  textColor: color.hex,
                                });
                              }}
                            />
                          </>
                        ) : null}
                      </Item>
                    </>
                  )}
              </>
            )}

            {TemplateDialogCount.typeContent !== 'youtube' &&
              TemplateDialogCount.typeContent !== 'mp4' &&
              TemplateDialogCount.typeContent !== 'iframe' && (
                <Item label="水平位置">
                  <Select
                    style={{ width: '100%' }}
                    value={TemplateDialogCount.textLevel}
                    onChange={(value) => {
                      setTemplateDialogCount({
                        ...TemplateDialogCount,
                        textLevel: value,
                      });
                    }}
                  >
                    <Option value="left">靠左</Option>
                    <Option value="center">置中</Option>
                    <Option value="right">靠右</Option>
                  </Select>
                </Item>
              )}
            {TemplateDialogCount.typeContent !== 'image' &&
              TemplateDialogCount.typeContent !== 'youtube' &&
              TemplateDialogCount.typeContent !== 'mp4' &&
              TemplateDialogCount.typeContent !== 'iframe' && (
                <Item label="垂直位置">
                  <Select
                    style={{ width: '100%' }}
                    value={TemplateDialogCount.textVertical}
                    onChange={(value) => {
                      setTemplateDialogCount({
                        ...TemplateDialogCount,
                        textVertical: value,
                      });
                    }}
                  >
                    <Option value="start">靠上</Option>
                    <Option value="center">置中</Option>
                    <Option value="end">靠下</Option>
                  </Select>
                </Item>
              )}

            {TemplateDialogCount.typeContent !== 'youtube' &&
              TemplateDialogCount.typeContent !== 'mp4' && (
                <Item label="時間">
                  <Input
                    placeholder="Basic usage"
                    addonAfter={selectAfter}
                    value={TemplateDialogCount.seconds}
                    onChange={(e) => {
                      if (!isNaN(e.target.value)) {
                        if (
                          parseInt(e.target.value, 10) <= 0 ||
                          e.target.value === ''
                        ) {
                          setTemplateDialogCount({
                            ...TemplateDialogCount,
                            seconds: '',
                          });
                        } else {
                          setTemplateDialogCount({
                            ...TemplateDialogCount,
                            seconds: parseInt(e.target.value, 10),
                          });
                        }
                      }
                    }}
                  />
                </Item>
              )}
            {TemplateDialogCount.typeContent === 'youtube' && (
              <>
                <Item label="網址" required>
                  <Input
                    value={TemplateDialogCount.typeFormat}
                    placeholder="例如：https://www.youtube.com...."
                    onChange={(e) => {
                      let H = 0,
                        M = 0,
                        S = 0;
                      let video_id;
                      if (e.target.value.indexOf('?v=') > 0) {
                        video_id = e.target.value.split('?v=')[1];
                        if (video_id.indexOf('&') > 0) {
                          video_id = video_id.split('&')[0];
                        }
                        //key是申請 Youtube Data API V3
                        axios(
                          'https://www.googleapis.com/youtube/v3/videos?&part=contentDetails&id=' +
                            video_id +
                            '&key=AIzaSyBpXOrUa11AL4oZryfsfJVL0YtrAipsxd8',
                          {
                            method: 'GET',
                          }
                        ).then((res) => {
                          const PT =
                            res.data.items[0].contentDetails.duration.slice(
                              2,
                              res.data.items[0].contentDetails.duration.length
                            );

                          console.log(PT);
                          if (PT.indexOf('H') > 0) {
                            H = PT.split('H')[0] * 1;
                            if (PT.split('H')[1].indexOf('M') > 0)
                              M = PT.split('H')[1].split('M')[0] * 1;
                            if (PT.split('H')[1].indexOf('S') > 0)
                              S =
                                PT.split('H')[1].split('M')[1].split('S')[0] *
                                1;
                          } else if (PT.indexOf('M') > 0) {
                            M = PT.split('M')[0] * 1;
                            console.log(PT.split('M'));
                            if (PT.split('M')[1].indexOf('S') > 0)
                              S = PT.split('M')[1].split('S')[0] * 1;
                          } else if (PT.indexOf('S') > 0) {
                            S = PT.split('S')[0] * 1;
                          }
                          console.log(H, '===H');
                          console.log(M, '====M');
                          console.log(S, '====S');

                          // setEndTime(H * 3600 + M * 60 + S);
                          // setMaxEndTime(H * 3600 + M * 60 + S);
                          axios(
                            'https://www.googleapis.com/youtube/v3/videos?&part=snippet&id=' +
                              video_id +
                              '&key=AIzaSyBpXOrUa11AL4oZryfsfJVL0YtrAipsxd8',
                            {
                              method: 'GET',
                            }
                          ).then((result) => {
                            setTemplateDialogCount({
                              ...TemplateDialogCount,
                              typeFormat: e.target.value,
                              endTime: H * 3600 + M * 60 + S,
                              maxEndTime: H * 3600 + M * 60 + S,
                              seconds: H * 3600 + M * 60 + S,
                              startTime: 1,
                              url: video_id,
                              youtubeTitle: result.data.items[0].snippet.title,
                              sound: 0,
                            });
                          });
                        });
                      } else {
                        setTemplateDialogCount({
                          ...TemplateDialogCount,
                          typeFormat: e.target.value,
                          startTime: 1,
                          endTime: 10,
                          maxEndTime: 10,
                          seconds: 10,
                          url: '',
                          youtubeTitle: '',
                          sound: 0,
                        });
                      }
                      setTemplateDialogCount({
                        ...TemplateDialogCount,
                        typeFormat: e.target.value,
                      });
                    }}
                  />
                </Item>
                <Item label="標題">
                  <Input
                    value={TemplateDialogCount.youtubeTitle}
                    onChange={(e) => {
                      setTemplateDialogCount({
                        ...TemplateDialogCount,
                        youtubeTitle: e.target.value,
                      });
                    }}
                  />
                </Item>
                <Item label="開始播放">
                  <InputNumber
                    min={1}
                    max={TemplateDialogCount.maxEndTime}
                    suffix="秒"
                    value={TemplateDialogCount.startTime}
                    onChange={(value) => {
                      setTemplateDialogCount({
                        ...TemplateDialogCount,
                        startTime: value,
                        seconds:
                          TemplateDialogCount.endTime * 1 - value * 1 + 1,
                      });
                    }}
                  />
                </Item>
                <Item
                  label={`結束播放(最大${TemplateDialogCount.maxEndTime}秒)`}
                >
                  <InputNumber
                    suffix="秒"
                    min={1}
                    max={TemplateDialogCount.maxEndTime}
                    value={TemplateDialogCount.endTime}
                    onChange={(value) => {
                      setTemplateDialogCount({
                        ...TemplateDialogCount,
                        endTime: value,
                        seconds:
                          value * 1 - TemplateDialogCount.startTime * 1 + 1,
                      });
                    }}
                  />
                </Item>
                <Item label="聲音">
                  <Switch
                    checkedChildren="開啟"
                    unCheckedChildren="關閉"
                    checked={TemplateDialogCount.sound === 0 ? true : false}
                    // style={{ marginRight: 10 }}
                    onChange={(checked) => {
                      console.log(checked);
                      setTemplateDialogCount({
                        ...TemplateDialogCount,
                        sound: checked ? 0 : 1,
                      });
                    }}
                  />
                </Item>
              </>
            )}
            {TemplateDialogCount.typeContent === 'mp4' && (
              <>
                <Item label="標題">
                  <Input
                    value={TemplateDialogCount.youtubeTitle}
                    onChange={(e) => {
                      setTemplateDialogCount({
                        ...TemplateDialogCount,
                        youtubeTitle: e.target.value,
                      });
                    }}
                  />
                </Item>
                <Item label="影片" required>
                  {/* <Input /> */}
                  <Space wrap>
                    <Button
                      onClick={() => {
                        uploadRef.current.click();
                        setSoundLoading(true);
                      }}
                    >
                      {backgroundMusic ? '更換附件' : '上傳附件'}
                    </Button>
                    {uploadData && (
                      <>
                        <Typography.Text type="secondary">
                          {uploadData.name}
                        </Typography.Text>
                        <Button
                          text
                          onClick={() => {
                            setUploadData(null);
                            setUploadPath('');
                          }}
                          style={{ opacity: 0.45, marginLeft: 10 }}
                        >
                          <DeleteOutlined className={styles.boxIcon} />
                        </Button>
                      </>
                    )}
                    {!uploadData && backgroundMusic && (
                      <>
                        <Typography.Text type="secondary">
                          {backgroundMusic.name}
                        </Typography.Text>
                        <Button
                          text
                          onClick={() => {
                            setBackgroundMusic(null);
                          }}
                          style={{ opacity: 0.45, marginLeft: 10 }}
                        >
                          <DeleteOutlined className={styles.boxIcon} />
                        </Button>
                      </>
                    )}
                  </Space>
                  <input
                    ref={uploadRef}
                    type="file"
                    id="upload"
                    accept=".mp4"
                    value={uploadPath || ''}
                    style={{ display: 'none' }}
                    onChange={async (e) => {
                      const file = e.target.files[0];
                      setUploadData(file);
                      setUploadPath(e.target.value);
                      const body = new FormData();
                      body.append('files', file);
                      const res = await fetch('/newUploads?type=broadcast', {
                        method: 'POST',
                        body,
                        headers: {
                          authorization: window.localStorage['feathers-jwt'],
                        },
                      });
                      const { showPath, _id, videoDuration } = await res.json();
                      setNewMp4({
                        videoDuration: Math.round(videoDuration / 1000),
                        path: showPath,
                        name: file.name,
                        id: _id,
                      });
                      setTemplateDialogCount({
                        ...TemplateDialogCount,
                        youtubeTitle: file.name.split('.')[0],
                      });
                      setSoundLoading(false);
                    }}
                  />
                </Item>

                <Item
                  label={`播放時間${
                    NewMp4.videoDuration === 0 &&
                    TemplateDialogCount?.maxEndTime
                      ? `(最大${TemplateDialogCount.maxEndTime}秒)`
                      : `(最大${NewMp4.videoDuration}秒)`
                  }`}
                >
                  <InputNumber
                    suffix="秒"
                    min={1}
                    max={
                      NewMp4.videoDuration === 0 &&
                      TemplateDialogCount?.maxEndTime
                        ? TemplateDialogCount.maxEndTime
                        : NewMp4.videoDuration
                    }
                    value={TemplateDialogCount.seconds}
                    onChange={(value) => {
                      setTemplateDialogCount({
                        ...TemplateDialogCount,
                        seconds: value * 1,
                      });
                    }}
                  />
                </Item>
                <Item label="聲音">
                  <Switch
                    checkedChildren="開啟"
                    unCheckedChildren="關閉"
                    checked={TemplateDialogCount.sound === 0 ? true : false}
                    // style={{ marginRight: 10 }}
                    onChange={(checked) => {
                      console.log(checked);
                      setTemplateDialogCount({
                        ...TemplateDialogCount,
                        sound: checked ? 0 : 1,
                      });
                    }}
                  />
                </Item>
              </>
            )}

            {TemplateDialogCount.typeContent === 'image' && (
              <div
                className={styles.showAddText}
                style={{
                  display: 'flex',
                  backgroundColor: broadcastContent[index]?.color,
                  backgroundImage: `url(${TemplateDialogCount.typeFormat})`,
                  height: '10vw',
                  backgroundSize:
                    (TemplateDialogCount.textSize === 'fullVersion' &&
                      'cover') ||
                    (TemplateDialogCount.textSize === 'originalSize' &&
                      'Contain') ||
                    (TemplateDialogCount.textSize === 'repeat' && 'Contain'),
                  backgroundRepeat:
                    TemplateDialogCount.textSize === 'repeat'
                      ? 'repeat'
                      : 'no-repeat',
                  backgroundPosition: TemplateDialogCount.textLevel,
                }}
              />
            )}
            {TemplateDialogCount.typeContent !== 'image' &&
              TemplateDialogCount.typeContent !== 'youtube' &&
              TemplateDialogCount.typeContent !== 'mp4' && (
                <div
                  className={styles.showAddText}
                  style={{
                    display: 'flex',
                    backgroundColor: broadcastContent[index]?.color,
                    fontSize: TemplateDialogCount.textSize,
                    color: TemplateDialogCount.textColor,
                    fontWeight:
                      TemplateDialogCount.textTags.indexOf('粗體') >= 0
                        ? '900'
                        : 'normal',
                    fontStyle:
                      TemplateDialogCount.textTags.indexOf('斜體') >= 0
                        ? 'italic'
                        : 'normal',
                    justifyContent: TemplateDialogCount.textLevel,
                    paddingTop:
                      (TemplateDialogCount.textVertical === 'start' && 0) ||
                      (TemplateDialogCount.textVertical === 'center' && 40) ||
                      (TemplateDialogCount.textVertical === 'end' && 80),
                    paddingBottom:
                      (TemplateDialogCount.textVertical === 'start' && 80) ||
                      (TemplateDialogCount.textVertical === 'center' && 40) ||
                      (TemplateDialogCount.textVertical === 'end' && 0),
                  }}
                >
                  文字內容
                </div>
              )}
          </Form>
        </Spin>
      </Dialog>

      {/* 媒體庫匯入 */}
      <Dialog
        hasMask
        className={styles.dialogMedia}
        visible={TemplateImageDialog}
        onOk={() => {
          setTemplateImageDialog(false);
          // setTypeContent('image');
          onChangeTemplateContent('image');
        }}
        onCancel={() => {
          setTemplateImageDialog(false);
          onChangeInitialValue();
        }}
        onClose={() => {
          setTemplateImageDialog(false);
          onChangeInitialValue();
        }}
      >
        <h3>媒體庫匯入</h3>
        <div>
          <div className={styles.MediaSearch}>
            類別：
            <Select
              onChange={(value) => {
                setMediaType(value);
                onChangeMediaType(value);
              }}
              value={mediaType}
            >
              <Option value="all">全部</Option>
              <Option value="announceBroadcast">公告</Option>
              <Option value="broadcast">公播</Option>
            </Select>
          </div>
          <div className={styles.MediaBtn}>
            <span style={{ color: '#FF0000', marginRight: 10 }}>
              *可上傳jpeg/png
            </span>
            <Upload
              accept="image/jpeg,image/png"
              multiple={true}
              showUploadList={false}
              beforeUpload={(file) => beforeUpload(file)}
            >
              <Button style={{ marginRight: 10 }}>
                <UploadOutlined />
                新增圖片
              </Button>
            </Upload>

            <Button
              className={styles.boxRowBtn}
              onClick={() => {
                Swal.fire({
                  title: '您確定要刪除圖片嗎?',
                  text: '刪除將無法復原',
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#BEBEBE',
                  confirmButtonText: '確定',
                  cancelButtonText: '取消',
                }).then((result) => {
                  if (result.isConfirmed) {
                    onDeleteBox();
                  }
                });
              }}
            >
              <DeleteOutlined className={styles.boxIcon} />
              刪除圖片
            </Button>
          </div>
        </div>

        <div className={styles.MediaContent}>
          <Spin spinning={upLoading}>
            <Checkbox.Group
              style={{ width: '100%' }}
              onChange={(value) => {
                onChange(value);
              }}
              className={styles.MediaImage}
            >
              <Row>
                {mediaImage
                  ? mediaImage.map((i, index) => (
                      <Col span={4} key={index}>
                        <Checkbox value={i.showPath}>
                          <div className={styles.MediaImage}>
                            <img
                              src={i.showPath}
                              width="100%"
                              height="100%"
                              alt="圖片"
                            />
                          </div>

                          <div className={styles.MediaImageName}>
                            {i.orignalName.includes('announceBroadcast') > 0
                              ? '公告'
                              : '公播'}
                            <br />
                            {mediaIndex === index ? (
                              <Input
                                value={mediaUpdate[0]}
                                suffix={`.${mediaUpdate[1]}`}
                                onChange={(e) => {
                                  if (e.target.value === '') {
                                    Message.error('請輸入檔案名稱');
                                  } else {
                                    setMediaUpdate([
                                      e.target.value,
                                      mediaUpdate[1],
                                    ]);
                                  }
                                }}
                              />
                            ) : (
                              i.oldName
                            )}

                            <br />
                            {mediaIndex === index ? (
                              <div>
                                <CheckOutlined
                                  style={{ color: '#006030' }}
                                  onClick={() => {
                                    uploads.patch(i._id, {
                                      ...i,
                                      oldName: mediaUpdate.join('.'),
                                    });
                                    setMediaIndex('');
                                    setIsUpdate((pre) => !pre);
                                  }}
                                />
                                <CloseOutlined
                                  style={{ color: '#CE0000', marginLeft: 10 }}
                                  onClick={() => {
                                    setMediaIndex('');
                                    setIsUpdate((pre) => !pre);
                                  }}
                                />
                              </div>
                            ) : (
                              <EditOutlined
                                onClick={() => {
                                  setMediaIndex(index);
                                  setMediaUpdate(i.oldName.split('.'));
                                }}
                              />
                            )}
                          </div>
                        </Checkbox>
                      </Col>
                    ))
                  : null}
              </Row>
            </Checkbox.Group>
          </Spin>
        </div>
      </Dialog>

      {/* 媒體庫更換圖片 */}
      <Dialog
        hasMask
        className={styles.dialogMedia}
        visible={TemplateImageChangeDialog}
        onOk={() => {
          setTemplateImageChangeDialog(false);
        }}
        onCancel={() => {
          setTemplateImageChangeDialog(false);
        }}
        onClose={() => {
          setTemplateImageChangeDialog(false);
        }}
      >
        <h3>更換圖片</h3>
        <div>
          <div className={styles.MediaSearch}>
            類別：
            <Select
              onChange={(value) => {
                setMediaType(value);
                onChangeMediaType(value);
              }}
              value={mediaType}
            >
              <Option value="all">全部</Option>
              <Option value="announceBroadcast">公告</Option>
              <Option value="broadcast">公播</Option>
            </Select>
          </div>
          <div className={styles.MediaBtn}>
            <Upload
              accept="image/jpeg,image/png"
              multiple={true}
              showUploadList={false}
              beforeUpload={(file) => beforeUpload(file)}
            >
              <Button style={{ marginRight: 10 }}>
                <UploadOutlined />
                新增圖片
              </Button>
            </Upload>
          </div>
        </div>

        <div className={styles.MediaContent}>
          <Spin spinning={upLoading}>
            <Radio.Group
              style={{ width: '100%' }}
              onChange={(value) =>
                setTemplateDialogCount({
                  ...TemplateDialogCount,
                  typeFormat: value,
                })
              }
              // className={styles.MediaImage}
              value={TemplateDialogCount.typeFormat}
            >
              <Row>
                {mediaImage
                  ? mediaImage.map((i, index) => (
                      <Col
                        span={4}
                        key={index}
                        style={{ paddingRight: 8, paddingLeft: 8 }}
                      >
                        <Radio value={i.showPath}>
                          <div className={styles.MediaImage}>
                            <img
                              src={i.showPath}
                              width="100%"
                              height="100%"
                              alt="圖片"
                            />
                          </div>

                          <div
                            className={styles.MediaImageName}
                            style={{ paddingTop: 10 }}
                          >
                            {i.orignalName.includes('announceBroadcast') > 0
                              ? '公告'
                              : '公播'}
                            <br />

                            {i.oldName}
                          </div>
                        </Radio>
                      </Col>
                    ))
                  : null}
              </Row>
            </Radio.Group>
          </Spin>
        </div>
      </Dialog>

      {/* 即時空氣品質欄位項目編輯 */}
      <Dialog
        hasMask
        className={styles.dialogType}
        visible={typeValueDialog}
        onOk={() => {
          setTypeValueDialog(false);
          setTemplateDialogCount({
            ...TemplateDialogCount,
            typeFormat: typeValueData,
          });
          // form.submit();
        }}
        onCancel={() => {
          setTypeValueDialog(false);
        }}
        onClose={() => {
          setTypeValueDialog(false);
        }}
      >
        <h3>項目編輯</h3>
        <Form inline colon>
          <Item label="裝置名稱" required>
            <Select
              value={typeValue?.originName}
              style={{ width: '150px' }}
              onChange={(value) => {
                const newUnit = unit.filter((i) => value.includes(i.name));
                const newData = {
                  originName: value,
                  newName: value,
                  ...newUnit[0],
                };
                setTypeValue(newData);
              }}
            >
              {typeColumns.map((i, index) => (
                <Option value={i} key={index}>
                  {i}
                </Option>
              ))}
            </Select>
          </Item>
          <Item label="顯示名稱" required>
            <Input
              value={typeValue?.newName}
              onChange={(e) => {
                const newData = { ...typeValue };
                newData.newName = e.target.value;
                setTypeValue(newData);

                const res = typeValueData.filter(
                  (item) => item.newName === e.target.value
                );
                if (res.length > 0) {
                  Message.error('顯示名稱不能重複');
                  setErrorText('顯示名稱不能重複');
                } else {
                  setErrorText('');
                }
              }}
            />
            {errorText && <p style={{ color: '#FF0000' }}>{errorText}</p>}
          </Item>
          <Item>
            <Button
              type="primary"
              onClick={() => {
                if (typeValue?.originName && typeValue?.newName) {
                  const res = typeValueData.filter(
                    (item) => item.newName === typeValue.newName
                  );
                  if (res.length > 0) {
                    Message.error('顯示名稱不能重複');
                    setErrorText('顯示名稱不能重複');
                  } else {
                    const NewTypeValueData = [...typeValueData];
                    NewTypeValueData.push(typeValue);
                    setTypeValueData(NewTypeValueData);
                    setTypeValue(null);
                    setErrorText('');
                  }
                } else {
                  Message.error('請輸入裝置名稱與顯示名稱');
                }
              }}
            >
              新增
            </Button>
          </Item>
        </Form>
        <p>
          <font style={{ color: 'red' }}>*</font>可拖曳表格欄位變換順序
        </p>
        <ReactDragListView
          onDragEnd={(fromIndex, toIndex) =>
            onTypeDragCategoryEnd(fromIndex, toIndex)
          }
        >
          <Table dataSource={typeValueData}>
            <Table.Column title="裝置名稱" dataIndex="originName" />
            <Table.Column
              title="顯示名稱"
              dataIndex="newName"
              render={(value, record, index) => {
                if (editable === index) {
                  return (
                    <>
                      <Input
                        value={typeValueData[index].newName}
                        onChange={(e) => {
                          const newData = [...typeValueData];
                          const res = newData.filter(
                            (item) => item.newName === e.target.value
                          );
                          if (res.length > 0) {
                            Message.error('顯示名稱不能重複');
                            setErrorTable('顯示名稱不能重複');
                            newData[index].newName = e.target.value;
                            setTypeValueData(newData);
                          } else {
                            setErrorTable('');
                            newData[index].newName = e.target.value;
                            setTypeValueData(newData);
                          }
                        }}
                      />
                      {errorTable && (
                        <p style={{ color: '#FF0000' }}>{errorTable}</p>
                      )}
                    </>
                  );
                } else {
                  return <span>{value}</span>;
                }
              }}
            />
            <Table.Column
              title="倍率"
              dataIndex="unitValue"
              render={(value, record, index) => {
                if (editable === index) {
                  return (
                    <Input
                      value={value}
                      onChange={(e) => {
                        const newData = [...typeValueData];
                        newData[index].unitValue = e.target.value;
                        setTypeValueData(newData);
                      }}
                    />
                  );
                } else {
                  return <span>{value}</span>;
                }
              }}
            />
            <Table.Column
              title="單位"
              dataIndex="unitName"
              render={(value, record, index) => {
                if (editable === index) {
                  return (
                    <Input
                      value={value}
                      onChange={(e) => {
                        const newData = [...typeValueData];
                        newData[index].unitName = e.target.value;
                        setTypeValueData(newData);
                      }}
                    />
                  );
                } else {
                  return <span>{value}</span>;
                }
              }}
            />
            <Table.Column
              title="操作"
              width={200}
              render={(value, record, index) => {
                return (
                  <>
                    {editable !== index && (
                      <>
                        <Button
                          type="normal"
                          className={styles.buttonAdd}
                          onClick={() => {
                            console.log(index);
                            setEditable(index);
                          }}
                        >
                          編輯
                        </Button>
                        <Button
                          type="primary"
                          className={styles.buttonAdd}
                          warning
                          onClick={() => {
                            const newTypeValueData = [...typeValueData];
                            console.log(index);
                            newTypeValueData.splice(index, 1);
                            setTypeValueData(newTypeValueData);
                          }}
                        >
                          刪除
                        </Button>
                      </>
                    )}
                    {editable === index && (
                      <>
                        <Button
                          type="normal"
                          className={styles.buttonAdd}
                          onClick={() => {
                            setEditable('');
                          }}
                        >
                          確認
                        </Button>
                      </>
                    )}
                  </>
                );
              }}
            />
          </Table>
        </ReactDragListView>
      </Dialog>
    </>
  );
};

export default BroadcastTemplateContent;
